var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"box"},[_c('h3',[_vm._v("Tags")]),_c('div',{staticClass:"tagsContainer"},_vm._l((_vm.tags),function(tag){return _c('the-tag',{key:tag.id,attrs:{"tag":tag}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }